module.exports = __webpack_public_path__ + "static/media/check_mark.52d74005.svg";